<template>
  <div class="index bindingMobile container">
    <div class="form_section">
      <div class="form_item">
        <van-field
          v-model="phone"
          type="tel"
          placeholder="请输入填写手机号码"
          label="手机号"
        />
      </div>
      <div class="form_item">
        <van-field
          v-model="sms"
          center
          clearable
          label="验证码"
          placeholder="请输入短信验证码"
        >
          <template #button>
            <van-button size="small" type="primary" @click.native="sendCode"
              >获取验证码</van-button
            >
          </template>
        </van-field>
      </div>
    </div>
    <Button :button="button" @click.native="login" />

  </div>
</template>

<script>
import Button from "@/components/Button";

export default {
  name: "login",
  data() {
    return {
      phone: "",
      sms: "",
      button: "确定",
    };
  },
  components: {
    Button
  },
  mounted() {},
  methods: {
    async sendCode() {
      let reg = /^1[3|4|5|7|8][0-9]{9}$/; //验证规则
      let flag = reg.test(this.phone); //true
      if (this.phone.trim().length === 0) {
        this.$toast("请输入手机号");
        return;
      } else if (flag === false) {
        this.$toast("手机号格式不正确");
        return;
      }
      let data = {
        mobile: this.phone,
      };
      this.$api.SendCode(data);
    },
    async login() {
      let reg = /^1[3|4|5|7|8][0-9]{9}$/; //验证规则
      let flag = reg.test(this.phone); //true
      if (this.phone.trim().length === 0) {
        this.$toast("请输入手机号");
        return;
      } else if (flag === false) {
        this.$toast("手机号格式不正确");
        return;
      }
      if (this.sms.trim().length === 0) {
        this.$toast("请输入验证码");
        return;
      }
      let data = {
        mobile: this.phone,
        code: this.sms,
      };
      this.$api.bindingMobile(data);

      this.$toast("绑定成功");
    },
  },
};
</script>

<style scoped lang="scss">
.bindingMobile {
  width: 100%;
  position: relative;
  height: 100vh;
  overflow: hidden;
  // background-color: #eee !important;
  .bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
  .header {
    position: relative;
    width: 100%;
    text-align: center;
    padding-top: 50px;
    padding-bottom: 20px;
    color: #ffffff;
    .title_big {
      font-size: 31px;
      margin-bottom: 13px;
    }

    .title_small {
      font-size: 21px;
    }
  }

  .form_section {
    padding: 0;
    box-sizing: border-box;
    position: relative;
    background-color: #fff;
    .form_item {
      height: 50px;
      border-bottom: 1px solid #e9e9e9;
      .van-cell {
        height: 100%;
        line-height: 100%;
        display: flex;
        align-items: center;
        /deep/ .van-field__label {
          font-weight: bold;
          font-size: 14px;
        }
        /deep/ .van-button {
          background-color: #fff;
          color: #cb0a08;
          border: none;
        }
      }
      input::-webkit-input-placeholder {
        color: rgba(202, 9, 8, 0.6);
      }
      input {
        display: block;
        width: 100%;
        background-color: transparent;
        border: none;
        outline: none;
        font-size: 14px;
        color: #cb0a08;
        padding-bottom: 8px;
        padding-top: 13px;
        border-bottom: 1px solid rgba(202, 9, 8, 0.6);
      }
    }
  }

  .register_btn {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 300px;
    height: 42px;
    margin: 100px auto 0;
    img {
      width: 300px;
      height: 42px;
      background-image: linear-gradient(0deg, #e10019 0%, #f5531a 100%);
      box-shadow: 0px 1.5px 6px 0px rgba(203, 10, 8, 0.26);
      border-radius: 40px;
    }
    span {
      position: absolute;
      font-size: 18px;
      color: #f8f3cd;
    }
  }
}
</style>
